import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useMe } from '../../../features/profile/use-me';
import { ProfileForm } from '../../../features/profile/profile-form';
import { Spinner } from '../../../components/ui/spinner';

export const Route = createFileRoute('/_auth/settings/profile')({
  component: ProfilePage,
});

function ProfilePage() {
  const { t } = useTranslation();
  const me = useMe();

  return (
    <div className="mx-auto w-full max-w-2xl px-4 pt-2 pb-12 md:px-10 md:pt-4 md:pb-20">
      {me.isLoading && (
        <div className="flex justify-center py-16">
          <Spinner size="lg" />
        </div>
      )}
      {me.isError && <p className="text-sm text-[var(--color-danger)]">{t('common.error')}</p>}
      {me.data && <ProfileForm me={me.data} />}
    </div>
  );
}
